import config from "../config";
import { get, post } from "../http";

const service = {
  createChangeRecord,
  getRecords,
};

async function createChangeRecord(
  {
    user: { fullName, email, id },
    companyId,
    subsidiaryId,
    module,
    submodule,
    changes,
  },
  token
) {
  const headers = {
    "Content-Type": "application/json",
    authorization: `Bearer ${token}`,
  };
  const body = {
    user: { fullName, email, id },
    companyId,
    subsidiaryId,
    module,
    submodule,
    changes,
  };
  return await post(
    `${config.recordsMicroserviceUrlApi}/records/create`,
    headers,
    body
  );
}

async function getRecords({
  companyId,
  limit,
  page,
  subsidiaryId = null,
  orderBy,
  order,
  module = null,
  submodule = null,
}) {
  const headers = {
    "Content-Type": "application/json",
    //authorization: `Bearer ${token}`,
  };

  let query = new URLSearchParams();
  query.append("companyId", companyId);
  if (subsidiaryId) query.append("subsidiaryId", subsidiaryId);
  if (submodule) query.append("submodule", submodule);
  if (module) query.append("module", module);
  if (limit) query.append("limit", limit);
  if (page) query.append("page", page);
  if (orderBy) query.append("orderBy", orderBy);
  if (order) query.append("order", order);

  return await get(
    `${
      config.recordsMicroserviceUrlApi
    }/records/getChangeRecords?${query.toString()}`,
    headers
  );
}

export default service;
